var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
            'hd-update p-0': true,
            'position-relative': _vm.$detect == 'web',
            'hd-update-mobile': _vm.$detect == 'mobile'
        }},[_c('div',[_c('div',{staticClass:"title border-bottom border-primary"},[_c('div',{staticClass:"d-flex justify-content-between"},[_c('div',{class:{
                    'py-10px px-3': _vm.$detect == 'web',
                    'pt-1 pb-2': _vm.$detect == 'mobile',
                    'fw-600' : true
                }},[_vm._v("Hộp thư đến")]),(_vm.hoidap.update_status)?_c('div',{staticClass:"btn-update",attrs:{"role":"button"},on:{"click":function($event){_vm.activeUpdate = true}}},[_c('i',{staticClass:"icon ion-md-create mr-2"}),_vm._v("Chỉnh sửa ")]):_vm._e()])]),_c('div',{class:{
                'body': true,
                'p-3': _vm.$detect == 'web'
            }},[_c('div',{staticClass:"title-faq"},[_c('p',{staticClass:"mb-0"},[_vm._v("Người gửi: "+_vm._s(_vm.hoidap.sender_loginname))])]),_c('div',{staticClass:"category-faq mt-3"},[_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.hoidap.title))])]),_c('div',{staticClass:"des-faq mt-3",domProps:{"innerHTML":_vm._s(_vm.hoidap.content)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }